import { gql } from "@apollo/client";

import { VAN_SURVEY_QUESTION_FIELDS } from "src/graphql/fragments";

export const GET_QUESTION_DATA = gql`
  ${VAN_SURVEY_QUESTION_FIELDS}
  query getCampaignVanSurveyQuestionData(
    $campaignId: ID!
    $vanSurveyQuestionId: Int!
  ) {
    campaign(id: $campaignId) {
      vanIntegration {
        surveyQuestion(surveyQuestionId: $vanSurveyQuestionId) {
          ...VanSurveyQuestionFields
        }
      }
    }
  }
`;
